import React from "react";
import { MIN_PX, MAX_PX } from "../constants";
import "./ZoomSlider.css";

interface Props {
  /** Current pixels-per-day (the raw slider lever — may sit below fit-to-width). */
  pxPerDay: number;
  /** The 6-week-lookahead default — marked + magnet-snapped on the track. */
  defaultPx: number;
  /** Center-day-preserving zoom commit. */
  onZoom: (n: number) => void;
  /** "~6 weeks" / "Full project" — computed by the board hook. */
  readout: string;
}

/** Drag within this many px/day of the default snaps to it (a soft magnet). */
const SNAP = 2;

const CalendarIcon: React.FC = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <path d="M16 2v4M8 2v4M3 10h18" />
  </svg>
);

/** Continuous board zoom: one slider = pixels-per-day. Past fit-to-width the
 *  time axis is pinned and the slider just keeps compressing rows. A notch marks
 *  the 6-week-lookahead default. */
const ZoomSlider: React.FC<Props> = ({ pxPerDay, defaultPx, onZoom, readout }) => {
  const range = Math.max(1, MAX_PX - MIN_PX);
  const frac = Math.min(1, Math.max(0, (defaultPx - MIN_PX) / range));
  return (
    <div className="takt-zoom">
      <span className="takt-zoom__icon"><CalendarIcon /></span>
      <div className="takt-zoom__track">
        <input
          type="range"
          className="takt-zoom__range"
          min={MIN_PX}
          max={MAX_PX}
          step={1}
          value={pxPerDay}
          onChange={(e) => {
            const v = Number(e.target.value);
            onZoom(Math.abs(v - defaultPx) <= SNAP ? defaultPx : v);
          }}
          onDoubleClick={() => onZoom(defaultPx)}
          aria-label="Board zoom — weeks shown"
        />
        <span
          className="takt-zoom__default"
          style={{ left: `calc(7px + (100% - 14px) * ${frac.toFixed(4)})` }}
          title="Default · 6-week lookahead (double-click to reset)"
        />
      </div>
      <span className="takt-zoom__val">{readout}</span>
    </div>
  );
};

export default ZoomSlider;
